import script from "./FuturesPositions.vue?vue&type=script&setup=true&lang=js"
export * from "./FuturesPositions.vue?vue&type=script&setup=true&lang=js"

import "./FuturesPositions.vue?vue&type=style&index=0&id=43319c61&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-43319c61"]])

export default __exports__